exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#header{height:600px;padding:60px;background:#fff}#banner,#header{position:relative}#banner{width:100%;top:50%;left:50%;margin-top:-.8em;transform:translate(-50%,-50%);z-index:2}#salesforcelogo{width:140px;height:auto;margin:1em}#salesforcelogo,#title{display:inline-block;vertical-align:middle}h1{font-size:2em}h1,h2{font-weight:400;margin:0}h2{font-size:1.325em;color:#7a7a7a}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-e5f3a3d8!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/DashboardHeader.vue
// module id = 10
// module chunks = 0